import { eventTimeline } from '@/mocks/home';

export default function EventTimeline() {
  return (
    <section id="events" className="w-full border-t border-background-200 bg-background-100 px-4 md:px-8 py-12 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4 border-b border-background-300 pb-5">
        <div>
          <span className="text-xs font-label tracking-[0.3em] text-primary-600">05 / 事件脉络</span>
          <h3 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">一件事的来龙去脉</h3>
        </div>
        <p className="max-w-md text-sm leading-6 text-foreground-600">
          从最早出现的时间点排到最近，节点之间按阶段收拢，不必来回翻页。
        </p>
      </div>

      <ol className="mt-10 grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-4">
        {eventTimeline.map((item, i) => (
          <li
            key={item.date}
            className={[
              'relative border-t-2 border-background-300 pt-5',
              i === eventTimeline.length - 1 ? 'md:border-t-primary-500' : '',
            ].join(' ')}
          >
            <span className="absolute -top-[7px] left-0 w-3 h-3 rounded-full bg-accent-500" />
            <div className="flex items-center gap-2">
              <span className="font-heading text-base md:text-lg font-bold text-foreground-950">{item.date}</span>
              <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-label text-secondary-900">
                {item.stage}
              </span>
            </div>
            <h4 className="mt-3 text-base font-medium text-foreground-900">{item.title}</h4>
            <p className="mt-2 text-sm leading-6 text-foreground-600">{item.summary}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}